import Nullstack from 'nullstack';
export default function IconNetwork({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-network",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "9",
    r: "6"
  }), "   ", Nullstack.element("path", {
    d: "M12 3c1.333 .333 2 2.333 2 6s-.667 5.667 -2 6"
  }), "   ", Nullstack.element("path", {
    d: "M12 3c-1.333 .333 -2 2.333 -2 6s.667 5.667 2 6"
  }), "   ", Nullstack.element("path", {
    d: "M6 9h12"
  }), "   ", Nullstack.element("path", {
    d: "M3 19h7"
  }), "   ", Nullstack.element("path", {
    d: "M14 19h7"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M12 15v2"
  }), " ");
}